const attributes = {
  name: 'naam',
  email: 'e-mail',
  password: 'wachtwoord',
}

export default attributes
